import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "output" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")
  const _component_ObjectViewer = _resolveComponent("ObjectViewer")
  const _component_OutputModal = _resolveComponent("OutputModal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.input, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.name,
        class: "output-item"
      }, [
        _createVNode(_component_Button, {
          tiny: "",
          class: "show-output",
          onClick: $event => ($options.open(item))
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("Show output")
          ]))]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
        _createVNode(_component_ObjectViewer, {
          class: "output-block",
          object: item.value,
          "root-name": item.name,
          onClick: _withModifiers($event => ($options.open(item)), ["ctrl"])
        }, null, 8 /* PROPS */, ["object", "root-name", "onClick"])
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createVNode(_component_OutputModal, { ref: "modal" }, null, 512 /* NEED_PATCH */)
  ]))
}